import styled from 'styled-components';

export const Container = styled.div`
  height: ${props => props.height ? `${props.height}px` : '0px'};
`